{
 "text": "I love the creative process of set decoration – taking a script and bringing it to life. Working across TV and film, I’ve honed my skills in budgeting, organisation and collaborating closely with directors and lots of different departments. I’m a creative, detail-oriented person, and I’m keen to keep growing my career in set decoration, creating sets that are visually compelling."
}
